module.exports = __webpack_public_path__ + "img/service-fenan2.d80c577c.svg";